module.exports = __webpack_public_path__ + "img/topic_a@2x.49e16dd0.png";